import { SelectProps } from 'tdesign-react';
// utils
import { deepCopy } from '@/utils/common';
import { isArray, isArrayLen } from '@/utils/common/dataJudgment';

// 关闭下拉列表视窗
export const onCloseSelectPopup = () => {
  try {
    const $dom: any = document.getElementsByClassName('popup-shadow')[0];
    $dom?.click();
  } catch (e) {
    console.error('onClose', e);
  }
};

/** 下拉框 - 文本渲染逻辑 */
export const onSelectRenderText = (
  options: any[],
  value: any,
  config?: {
    displayOptions?: SelectProps['options'];
  },
) => {
  const { displayOptions = [] } = config || {};
  let vText: any = '';

  if (isArrayLen(options)) {
    let newOptions = [...options];

    if (isArrayLen(displayOptions)) {
      newOptions = newOptions.concat(displayOptions);
    }

    if (isArray(value)) {
      let textArr: any[] = [];

      value.map((i: any) => {
        let jsonText: any = newOptions.find((v) => v.value === i);
        if (jsonText) {
          textArr.push(jsonText);
        }
      });
      vText = textArr;
    } else {
      const jsonText: any = newOptions.find((v) => v.value === value) || {};

      vText = [jsonText];
    }
    return vText;
  }
};

const getCheckedCascaderItem = ({ options, value }: any) => {
  let obj = options.find((h: any) => h.value === value);
  return obj;
};
/** 级联下拉框 - 文本渲染逻辑 */
export const onCascaderSelectRenderText = (params: {
  options: any[];
  value: any;
  config?: {
    displayOptions?: SelectProps['options'];
  };
}) => {
  const { options, value, config } = params;
  const { displayOptions = [] } = config || {};
  let result: any = [];

  if (!isArrayLen(options)) return result;

  let newOptions = deepCopy(options);
  if (isArrayLen(displayOptions)) {
    newOptions = newOptions.concat(displayOptions);
  }
  for (let i = 0; i < value.length; i++) {
    let item = value[i];
    result[i] = [];

    let optionsArr = options;
    for (let v = 0; v < item.length; v++) {
      let value = item[v];
      let info = getCheckedCascaderItem({ options: optionsArr, value });
      if (info) {
        result[i].push(info);
        optionsArr = info?.children || [];
      }
    }
  }

  return result;
};

// 树形结构数据写入父级ID 和 当前链路涉及的父级ID
export const treeAddParentId = (
  tree: any[],
  parentId?: any,
  parentLinkId?: any[],
) => {
  tree.forEach((item) => {
    if (parentId) {
      item.parentId = parentId;
      item.parentLinkId = parentLinkId;
    } else {
      item.parentId = 0;
      item.parentLinkId = [];
    }

    let newArr = item.parentLinkId.map((v) => v);
    newArr.push(item.value);
    if (item.children && item.children.length > 0) {
      treeAddParentId(item.children, item.value, newArr);
    }
  });
  return tree;
};

// 级联选择器 - 筛选、选中显示内容间隔符
export const cascaderInterval = ' / ';

// 默认下拉项列表最大高度
export const defaultListMaxHeight = 265;
